site.megamenu = {
	init:function() {
		var $mainmenu = $('#mainmenu');
		$('.mmLevel2', $mainmenu).wrap('<div class="megamenu"><div class="wrap"><div class="contentWrap clearfix" /></div></div>');
		$mainmenu.on('click', function(e) {
			e.stopPropagation();
		});

		site.megamenu.addCloseButton();
		site.megamenu.loadPageInfo();

		$('.level1.children > a',$mainmenu).on('click touchStart', function (e) {
			if ($(document).width()+15 >= 768 && !$('body').hasClass('stillingar')) {
				e.preventDefault();
				e.stopPropagation();

				//Click on node that is already open
				if ($(this).parent().hasClass('open')) {
					site.megamenu.close();
				}
				//Open megamenu
				else {
					$('body').addClass('megamenu-open');
					$('.level1.open', $mainmenu).removeClass('open');

					$('.megamenu').removeAttr('style');

					$(this).parent().addClass('open');
					site.megamenu.setHeight();
				}

				$('body.megamenu-open').on('click touchStart', function (e) {
					site.megamenu.close();
				});
			}
		});

		$(window).resize(function() {
			site.megamenu.setHeight();
		});
	},

	setHeight:function() {
		var $megamenu = $('.megamenu', '#mainmenu .level1.open');
		if ($megamenu.length > 0) {
			var megamenuHeight = $megamenu[0].scrollHeight + 5,
				megaHeight = $('#mega').length ? $('#mega')[0].scrollHeight + 37 : 0;
			megamenuHeight = (megaHeight > megamenuHeight) ? megaHeight : megamenuHeight;
			$megamenu.css('max-height', megamenuHeight);
			$('#pageContainer').css('min-height', megamenuHeight+142);
		}
	},

	close:function() {
		var $body = $('body'),
			$mainmenu = $('#mainmenu');
		$('.megamenu', $mainmenu).removeAttr('style');
		$('.level1.open', $mainmenu).removeClass('open');
		$('#pageContainer').removeAttr('style');

		if ($body.hasClass('megamenu-open')) {
			$body.addClass('megamenu-closing');
			setTimeout(function() {
				$body.removeClass('megamenu-closing');
			},400);
		}
		$body.removeClass('megamenu-open');
	},

	addCloseButton: function() {
		$('.megamenu', '#mainmenu').each(function() {
			$(this).find('.contentWrap').append('<span class="close" />')
		});

		$('span.close', '.megamenu').on('click', function() {
			site.megamenu.close();
		});
	},

	loadPageInfo: function() {
		$('.megamenu', '#mainmenu').each(function() {
			var $megamenu = $(this),
				$li = $megamenu.parents('.level1'),
				$a = $li.find("> a:not(.expand)"),
				title = $a.text(),
				href = $a.attr('href'),
				codename = '',
				division = '';

			if(href.includes('/is/')) {
				division = 'is';
				codename = (href) ? href.replace('/is/', '') : '';
			}
			else if(href.includes('/english/')) {
				division = 'english';
				codename = (href) ? href.replace('/english/', '') : '';
			}

			$.ajax({
				url: '/_/' + division + '/page/index/index/_ui_' + division +'_megamenu-' + codename,
				type: 'get'
			}).done(function(r) {
				if (r.length) {
					title = '<div class="title"><span>' + title + '</span></div>';
					$megamenu.find('.contentWrap').prepend('<div class="pageContent">' + title + r + '</div>');
				}
			});

		});
	}
};
